(ns frontend.test.sortable-list
  (:require
   [ui.components.sortable-list.examples :as examples]))

(defn view
  []
  [:<>
   [examples/examples]])
